import './AdditionalInsured.css';

import { DescriptionOutlined } from '@material-ui/icons';
import React from 'react';

import Address from '../../../../components/Address/Address';
import Input from '../../../../components/Input/Input';
import SafeHtml from '../../../../components/SafeHtml';
import {
  AdditionalInsured as AdditionalInsuredInfo,
  UpdateCoverageInput
} from '../../../../generated/rating-quoting-graphql';
import { CoveragesDataInput } from '../..';
import {} from '../../Quote';
import usStateNationalCoveragesDetails from '../Coverages/configs/usGLStateNationalCoveragesDetails.json';

interface AdditionalInsuredCoverageProps {
  coverageData: CoveragesDataInput;
  onUpdateCoverage: (input: UpdateCoverageInput) => void;
  region: string;
  quoteId: string;
  applicationId: string;
  additionalInsuredInfoList: AdditionalInsuredInfo[] | undefined;
  setAdditionalInsuredInfoList: React.Dispatch<
    React.SetStateAction<AdditionalInsuredInfo[] | undefined>
  >;
  fillAllAdditionalInsuredInfo: boolean | undefined;
  setFillAllAdditionalInsuredInfo: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;
  disabled: boolean;
}

const AdditionalInsured: React.FC<AdditionalInsuredCoverageProps> = (props) => {
  const {
    coverageData,
    onUpdateCoverage,
    region,
    quoteId,
    applicationId,
    additionalInsuredInfoList,
    setAdditionalInsuredInfoList,
    fillAllAdditionalInsuredInfo,
    setFillAllAdditionalInsuredInfo,
    disabled
  } = props;
  const { chooseCoverage: chooseAdditionalInsured } = coverageData;
  const title = 'Additional Insured - Completed Operations';

  return (
    <div
      className="additional-insured coverage grid grid-cols-1 md:grid-cols-8"
      id="additional-insured-container"
    >
      <div className="col-span-1 grid grid-cols-4">
        <input
          type="checkbox"
          data-name="addtional-insured-checkbox"
          className="flex justify-center items-center w-10 h-10 mt-2 col-span-1"
          checked={chooseAdditionalInsured}
          disabled={disabled}
          onClick={() =>
            onUpdateCoverage({
              quoteId,
              applicationId,
              region,
              coverage: {
                name: 'additionalInsured',
                chooseCoverage: !chooseAdditionalInsured,
                limits: { noLimit: 0 }
              }
            })
          }
        />
        <p className="col-span-3 md:hidden text-navy font-extrabold text-xl">
          {title}
        </p>
      </div>
      <DescriptionOutlined
        data-testid="additional-insured-icon"
        className="col-span-1 hidden md:block text-secondary"
        style={{ fontSize: '3.5rem' }}
      />
      <div className="col-span-1 md:col-span-6 pl-2 md:pl-0">
        <p>
          <b className="hidden md:block text-navy font-extrabold text-base md:text-2xl">
            {title}
          </b>
        </p>
        <p className="text-gray-700 text-xs md:text-base">
          Owners, Lessees or Contractors - Completed Operations (CG 20 37)
        </p>
        {chooseAdditionalInsured ? (
          <div className="additional-insured-details mt-2 flex flex-col gap-6">
            <span className="coverage-description text-gray-700 text-xs md:text-base inline-block">
              {usStateNationalCoveragesDetails.additionalInsured.subTitle && (
                <SafeHtml
                  html={
                    usStateNationalCoveragesDetails.additionalInsured.subTitle
                  }
                />
              )}
            </span>
            {fillAllAdditionalInsuredInfo === false ? (
              <span className="text-red-500 font-bold">
                Additional insured endorsement CG2037 is selected. Please
                provide additional insured information or deselect to proceed.
              </span>
            ) : null}
            {additionalInsuredInfoList?.map((info, infoIndex) => (
              <div key={infoIndex}>
                <Input
                  leftLabel="Name of additional insured person or organization"
                  onChange={(value) => {
                    setFillAllAdditionalInsuredInfo(undefined);
                    const newList = [...additionalInsuredInfoList];
                    newList[infoIndex].name = value;
                    setAdditionalInsuredInfoList(newList);
                  }}
                  value={info.name || ''}
                />
                <br />
                <Address
                  title="Address"
                  onChange={(value) => {
                    setFillAllAdditionalInsuredInfo(undefined);
                    const newList = [...additionalInsuredInfoList];
                    newList[infoIndex].address = value;
                    setAdditionalInsuredInfoList(newList);
                  }}
                  value={info.address || undefined}
                  preventStateOrProvinceChange={false}
                  country="US"
                  province=""
                  filterProvince={false}
                />
                <br />
                <Input
                  leftLabel="Additional insured contact email"
                  onChange={(value) => {
                    setFillAllAdditionalInsuredInfo(undefined);
                    const newList = [...additionalInsuredInfoList];
                    newList[infoIndex].email = value;
                    setAdditionalInsuredInfoList(newList);
                  }}
                  value={info.email || ''}
                />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AdditionalInsured;
